import { useState, useEffect } from 'react';
import { List, Datagrid, useRecordContext, TextField, EmailField, TextInput, ReferenceInput, SelectInput, ReferenceField, Edit, SimpleForm, useGetList, useDataProvider, Create, required, DateTimeInput } from 'react-admin';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

export const AddressList = (props) => {
    var record = useRecordContext();
    const dataProvider = useDataProvider();
    const [addresses, setAddresses] = useState();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();

    useEffect(() => {

        if(record != undefined){
            var id = record.clientId;
            if(record.hasOwnProperty("clientId"))
                id = record.clientId;

            dataProvider.getList('users/'+id+"/address", {
                pagination: { page: 1, perPage: 999999 },
                sort: { field: 'id', order: 'ASC' },
                filter: {  },
            })
            .then(({ data }) => {
                setAddresses(data);
                setLoading(false);
            })
            .catch(error => {
                setError(error);
                setLoading(false);
            });
        }
            
    }, [record]);

    if (loading) return <CircularProgress style={{margin: "auto"}} color="inherit" />;
    if (error) return <Typography variant="h6" color="red">Erreur lors du chargement des des adresses.</Typography>;
    if (!addresses) return null;

    if(addresses.length == 0) return <Typography variant="h6" color="inherit">Aucune adresse enregistrée.</Typography>;

    return (
        <div style={{width: "100%"}}>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                    <TableRow>
                        <TableCell>ID</TableCell>
                        <TableCell>Adresse</TableCell>
                        <TableCell>Compl 1</TableCell>
                        <TableCell>Compl 2</TableCell>
                        <TableCell>Code postal</TableCell>
                        <TableCell>Ville</TableCell>
                        <TableCell>Nom</TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                    {addresses.map((address) => (
                        <TableRow
                        key={address.id}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            <TableCell component="th" scope="row">
                                {address.id}
                            </TableCell>
                            <TableCell>{address.adress1}</TableCell>
                            <TableCell>{address.adress2}</TableCell>
                            <TableCell>{address.adress3}</TableCell>
                            <TableCell>{address.postalCode}</TableCell>
                            <TableCell>{address.city}</TableCell>
                            <TableCell>{address.wording}</TableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
};